import { client } from '../client'

export const groqFetch = async () =>{
   return client.fetch(`*[_type in ["category" , "product", "allergens", "drinksCategory", "drinksproduct", "info","highlights", "lunchMenu", "specialMenu2", "pdfMenu"]
    | order(importance asc)]{ 
        _type == "category"  =>{
          'type': 'category',
          title,
          title_eng,
          importance
        } ,     
        _type == "product" => {
        'type': 'product',
        title,
        title_eng,
        slug,
        publishedAt,
        price,
        instock,
          weight,
          _rev,
          body,
          body_eng,
        categories->{name, title,title_eng, importance},
        mainImage{
              asset->{
                  _id,
                  url
              },
            alt
          }
        }, _type == "lunchMenu" => {
          'type': 'lunchMenuProduct',
          title,
          title_eng,
          slug,
          publishedAt,
          price,
            weight,
            _rev,
            body,
            body_eng,
            instock,
          categories->{name, title,title_eng, importance},
          mainImage{
                asset->{
                    _id,
                    url
                },
              alt
            }
          }, _type == "specialMenu2" => {
          'type': 'specialMenu2Product',
          title,
          title_eng,
          slug,
          publishedAt,
          price,
            weight,
            _rev,
            body,
            body_eng,
            instock,
          categories->{name, title,title_eng, importance},
          mainImage{
                asset->{
                    _id,
                    url
                },
              alt
            }
          },
        _type == "drinksCategory" =>{
          'type': 'drinksCategory',
          title,
          title_eng,
          importance
        },
        _type == "drinksproduct" =>{
          'type': 'drinksProduct',
          title,
          title_eng,
          slug,
          publishedAt,
          price,
            weight,
            _rev,
            body,
            body_eng,
          drinksCategory->{name, title,title_eng, importance},
          mainImage{
                asset->{
                    _id,
                    url
                },
              alt
            }
        },
        _type == "info" =>{
          "type" : 'info',
          variation,
          variation_eng,
          workingHours,
          restDay,
          restDay_eng,
          telephone,
          address,
          address_eng,
          lunchHours
        },
        _type == "highlights" =>{
            "type": 'highlights',
            highlight1,
            highlight1_eng,
            highlight2,
            highlight2_eng,
            highlight1_drinks,
            highlight1_drinks_eng,
            highlight2_drinks,
            highlight2_drinks_eng
        },
        _type == "allergens" =>{
            "type": 'allergens',
            allergens_text
        },
        _type == "pdfMenu" =>{  
          "type": 'pdfFile',  
          "pdfUrl": pdfFile.asset->url},

      }`)
}